import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensUAZipPullover = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[23].productName}
				color={product.allGear[23].color}
				size={product.allGear[23].sizes}
				price={product.allGear[23].price}
				img={product.allGear[23].img}
				miniImg1={product.allGear[23].miniImg1}
				miniImg2={product.allGear[23].miniImg2}
				miniImg3={product.allGear[23].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensUAZipPullover;
